import Bouncer from 'formbouncerjs';

export const defaultConfig = {
  fieldClass: 'border-red',
  errorClass: 'text-red',
  messageAfterField: true,
  messages: {
    missingValue: {
      checkbox: 'Dit veld moet aangevinkt zijn.',
      radio: 'Dit veld mag niet leeg zijn.',
      select: 'Kies een optie.',
      'select-multiple': 'Kies minimaal één optie.',
      default: 'Dit veld mag niet leeg zijn.',
    },
    patternMismatch: {
      email: 'Vul een geldig e-mailadres in.',
      url: 'Vul een geldige URL in.',
      number: 'Vul een getal in.',
      date: 'Vul een geldige datum in.',
      time: 'Vul een geldige tijd in.',
      month: 'Vul een geldige maand in.',
      default: 'Vul een geldige waarde in.',
    },
    outOfRange: {
      over: 'Kies een waarde die niet groter is dan {max}.',
      under: 'Kies een waarde die niet kleiner is dan {min}.',
    },
    wrongLength: {
      over: 'Kies een waarde die niet langer is dan {maxLength} tekens. Je gebruikt momenteel {length} tekens.',
      under:
        'Kies een waarde die niet korter is dan {minLength} tekens. Je gebruikt momenteel {length} tekens.',
    },
    isURL: 'Vul een geldige URL in, beginnend met http:// of https://',
    valueMismatch: (field: HTMLInputElement) => {
      const customMessage = field.getAttribute('data-bouncer-mismatch-message');

      return customMessage ?? 'De waarden zijn niet gelijk.';
    },
  },
  customValidations: {
    isURL: (field: HTMLElement) => {
      const inputField = field as HTMLInputElement;
      // Skip validation if this field doesn't need URL validation
      if (!field.hasAttribute('data-validate') || field.getAttribute('data-validate') !== 'isURL') {
        return false;
      }

      if (!inputField.value) {
        return false;
      }

      // Regular expression for URL validation starting with http:// or https://
      const pattern = /^https?:\/\//;

      // Check if the field value matches the pattern
      return !pattern.test(inputField.value);
    },
    valueMismatch: (field: HTMLElement) => {
      const inputField = field as HTMLInputElement;
      const selector = inputField.getAttribute('data-bouncer-match');

      if (!selector || !inputField.form) {
        return false;
      }

      const otherField: HTMLInputElement | null = inputField.form.querySelector(selector);

      return otherField?.value !== inputField.value;
    },
  },
  emitEvents: true,
  disableSubmit: false,
};

const formConfig = {
  newsletter: {
    disableSubmit: true,
  },
  rdrParticipant: {
    disableSubmit: true,
  },
  clinicParticipant: {
    disableSubmit: true,
  },
  rdrEvent: {
    disableSubmit: true,
  },
};

export const initBouncerValidation = () => {
  const targets = document.querySelectorAll('[data-validate-form]');

  targets.forEach((target) => {
    if (target.hasAttribute('data-bouncer-identifier')) {
      return;
    }

    const formType = target.getAttribute('data-validate-form') as
      | keyof typeof formConfig
      | undefined;
    const formSpecificConfig = formType ? formConfig[formType] : {};
    const config = { ...defaultConfig, ...formSpecificConfig };
    const uniqueIdentifier = `bouncer-${Math.random().toString(36).substring(2, 15)}`;

    target.setAttribute('data-bouncer-identifier', uniqueIdentifier);
    target.classList.add(uniqueIdentifier);

    new Bouncer(`.${uniqueIdentifier}`, config);
  });

  return targets;
};
